import React from 'react'
import RtOvwPanel from '../components/RtOvwPanel'
import RtOvwLegend from '../components/RtOvwLegend'
import * as ImmutablePropTypes from "react-immutable-proptypes";
import * as Immutable from "immutable";
import {connect} from "react-redux";
import {Keys} from "../../model/constants/keys";
import UpdateInfo from '../components/UpdatedInfo'
import {loadWorkSessionItems} from "../../model/action-creators/item-actions";


class  OverviewPage extends React.Component {


    render() {
      const  assigneeFilter=(a) =>  {return !a.get(Keys.Assignee.QC_ITEMS, Immutable.Set()).isEmpty()};
      const  assigneeItemsGetter=(assignee, props) => { return assignee.get(Keys.Assignee.QC_ITEMS, Immutable.Set()).map(itemId => props.items.get(itemId))};
      const updateAction = () => this.props.currentWorkSession?this.props.dispatch(loadWorkSessionItems(this.props.currentWorkSession.get(Keys.ID))):null;


        return (

            <div className="app__page">
                <UpdateInfo baseState={this.props.itemsState} updateAction={updateAction}/>
                <h3>Retouchers</h3>
                <RtOvwPanel {...this.props} />
                <h3>QCs</h3>
                <RtOvwPanel {...this.props} assigneeFilter={assigneeFilter} assigneeItemsGetter={assigneeItemsGetter}/>
                <RtOvwLegend />
            </div>
        )
    }
}

OverviewPage.propTypes = {
    dispatch:React.PropTypes.func.isRequired,
    mutations:ImmutablePropTypes.map.isRequired,
    items:ImmutablePropTypes.map.isRequired,
    assignees:ImmutablePropTypes.map.isRequired,
    currentWorkSession:ImmutablePropTypes.map.isRequired,
    itemsState:ImmutablePropTypes.map.isRequired,
};

const mapSateToProps = (state) => {
    return {
        mutations: state.mutationsState.get(Keys.EditorIds.OVERVIEW_PAGE, Immutable.Map()),
        assignees: state.assigneesState.get(Keys.StoreSliceData.ASSIGNEES),
        items: state.itemsState.get(Keys.StoreSliceData.ITEMS),
        itemsState: state.itemsState,
        currentWorkSession: state.currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION,Immutable.Map()),

    }
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch:dispatch,
    }
};

export default connect(mapSateToProps, mapDispatchToProps)(OverviewPage);




// WEBPACK FOOTER //
// ./src/ui/pages/OverviewPage.js